/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Speed_TitleInputs */

const en_features_speed_title = /** @type {(inputs: Features_Speed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double your reading speed`)
};

const es_features_speed_title = /** @type {(inputs: Features_Speed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplica tu velocidad de lectura`)
};

/**
* | output |
* | --- |
* | "Double your reading speed" |
*
* @param {Features_Speed_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_speed_title = /** @type {((inputs?: Features_Speed_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Speed_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_speed_title(inputs)
	return en_features_speed_title(inputs)
});